module.exports = __webpack_public_path__ + "img/deviant1.23458fcd.jpg";